// ProductionTracking.js - "Suivi de production": every in-progress
// ProductionOrder stacked one under another, each with its own full
// timeline, so staff see the whole shop floor's status on one screen
// without opening each order individually. Sibling to the ProductionOrders
// list and the ProductionOrderDetail page under the same module.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "../Stock/Stock.css";
import { userRequest } from "../../RequestMethods";
import { getColorDisplayName } from "../../utils/colorNames";
import { TERMINAL_STATUS } from "../../Data/productionStatuses";
import { ProductionCycleTimelineCard } from "../../Components/ProductionCycleTimeline/ProductionCycleTimeline";
import "./ProductionTracking.css";

const ProductionTracking = () => {
  const navigate = useNavigate();
  const [productionOrders, setProductionOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [includeDone, setIncludeDone] = useState(false);

  const fetchProductionOrders = async () => {
    try {
      setLoading(true);
      const res = await userRequest.get("production-orders");
      setProductionOrders(res.data.productionOrders || []);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Erreur lors du chargement des ordres de production.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchProductionOrders(); }, []);

  const visible = includeDone
    ? productionOrders
    : productionOrders.filter((po) => po.status !== TERMINAL_STATUS);

  return (
    <div className="Stock">
      <h1>Suivi de production</h1>
      <div className="field-note">
        Toutes les productions en cours, empilées avec leur timeline complète — sans avoir à ouvrir chaque ordre.
      </div>

      <div className="pt-toolbar">
        <label className="pt-toggle">
          <input type="checkbox" checked={includeDone} onChange={(e) => setIncludeDone(e.target.checked)} />
          Inclure les productions terminées
        </label>
        <span className="pt-count">{visible.length} ordre{visible.length > 1 ? "s" : ""}</span>
      </div>

      {loading ? (
        <div className="loading-container"><div className="loading-spinner-custom"></div></div>
      ) : visible.length === 0 ? (
        <p>Aucune production en cours.</p>
      ) : (
        <div className="pt-stack">
          {visible.map((po) => (
            <div className="pt-item" key={po._id}>
              <div className="pt-item-header">
                <div>
                  <span
                    className="production-order-link"
                    onClick={() => navigate(`/production-orders/${po._id}`)}
                  >
                    {po.productTitle}{po.designId?.title ? ` — ${po.designId.title}` : ""}
                  </span>
                  <div className="field-note" style={{ marginTop: "4px" }}>
                    {po.color ? getColorDisplayName(po.color) : "—"} / {po.size} &nbsp;·&nbsp; Qté {po.quantity}
                    {po.assignedTo ? ` · Assigné à ${po.assignedTo.name || ""} ${po.assignedTo.surname || ""}`.trim() : ""}
                    {po.isRush ? " · ⚡ Urgent" : ""}
                  </div>
                </div>
                <button className="action-icon-btn btn-edit" onClick={() => navigate(`/production-orders/${po._id}`)}>
                  Détails
                </button>
              </div>
              <ProductionCycleTimelineCard
                status={po.status}
                hasDesign={!!po.designId}
                order={po.orderId || null}
              />
            </div>
          ))}
        </div>
      )}

      <ToastContainer position="top-right" />
    </div>
  );
};

export default ProductionTracking;
